import {
  Skeleton,
  Table,
} from "antd";
import "assets/fonticons/style.css";
import K from "utilities/constants";
import {
  checkNullPlaceHolder,
} from "utilities/generalUtility";
import { displayDollar } from "utilities/tableUtility";
import { stringSorter } from "utilities/sorting";

const {
  Invoice: { Type },
} = K;

export default function InvoiceClientBills({
  pageData,
  billModalPrepare,
}) {

  const { details } = pageData;

  const columns = [
    {
      title: "Description",
      dataIndex: "title",
      align: "center",
      render: (params) => checkNullPlaceHolder(params),
    },
    {
      title: "Billing Type",
      dataIndex: "billingTypeName",
      align: "center",
      render: (params) => checkNullPlaceHolder(params),
      defaultSortOrder: "ascend",
      sorter: stringSorter("billingTypeName"),
    },
    {
      title: "Price",
      dataIndex: "dublicateAmount",
      align: "center",
      render: (text) => displayDollar(+text.toFixed(2)),
    },
    {
      title: "Source",
      dataIndex: "source",
      align: "center",
      render: (source) => checkNullPlaceHolder(source?.name),
    },
  ];

  const dataSource = details?.submittedClientBills;

  const onRow = (record, rowIndex) => {
    return {
      onClick: (event) => {
        billModalPrepare(record);
      },
      style: { cursor: "pointer" },
    };
  };

  return (
    <>
        {details ? (
          <Table
            columns={columns}
            dataSource={dataSource}
            rowKey="id"
            size="small"
            pagination={false}
            className="invoiceTable"
            scroll={{ x: true }}
            onRow={onRow}
          />
        ) : (
          <Skeleton active paragraph={{ rows: 6 }} />
        )}
    </>
  );
}
